import React from "react";
import { ycCompanies } from "assets/ycCompanies";
import { Link } from "react-router-dom";
import moment from "moment";

const headerColumns = {
  company: {
    name: "Company",
    width: "25%",
  },
  orderId: {
    name: "ID",
    width: "5%",
  },
  username: {
    name: "Username",
    width: "10%",
  },
  role: {
    name: "Role",
    width: "20%",
  },
  location: {
    name: "Location",
    width: "15%",
  },
  status: {
    name: "Status",
    width: "5%",
  },
  dateCreated: {
    name: "Created",
    width: "10%",
  },
  lastActive: {
    name: "Last Active",
    width: "10%",
  },
};

export default function AdminSupportTable() {
  return (
    <table className="w-full text-sm text-left">
      <thead className="text text-gray-800 bg-gray-59">
        <tr>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.company.width }}>
            {headerColumns.company.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderId.width }}>
            {headerColumns.orderId.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.username.width }}>
            {headerColumns.username.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.role.width }}>
            {headerColumns.role.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.location.width }}>
            {headerColumns.location.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.status.width }}>
            {headerColumns.status.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.dateCreated.width }}>
            {headerColumns.dateCreated.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.lastActive.width }}>
            {headerColumns.lastActive.name}
          </th>
        </tr>
      </thead>
      <tbody>
        {ycCompanies.map((company) => {
          const { companyName } = company;
          var formattedCompanyName = companyName.substring(0, companyName.indexOf("("));
          formattedCompanyName = formattedCompanyName.trim().replace(/\s/g, "-").toLowerCase();
          const clusterURL = `/recruiters/@${formattedCompanyName}`;

          return (
            <tr className="cursor-pointer bg-white border-b hover:bg-gray-50 text-gray-700">
              <td className="flex items-center px-6 py-4">
                <img className="w-10 h-10 rounded-full" src={company.profileImageURL} alt={company.roleName} />
                <div className="pl-3">
                  <div className="text-base font-semibold">
                    <Link to={clusterURL}>{company.companyName}</Link>
                  </div>
                  <div className="font-normal">{company.location}</div>
                </div>
              </td>
              <td className="px-6 py-4">{Math.floor(Math.random()*10210)}</td>
              <td className="px-6 py-4">{`@${formattedCompanyName}`}</td>
              <td className="px-6 py-4">{company.roleName}</td>
              <td className="px-6 py-4">{company.location}</td>
              <td className="px-6 py-4">
                <div className="flex items-center">
                  <div className="h-2.5 w-2.5 rounded-full bg-green-500 mr-2" /> Active
                </div>
              </td>
              <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
              <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
